import React from 'react';
import Order from '@/modules/Order';
import OrderPharmacy from '@/modules/OrderPharmacy';
import Promo from '@/modules/Promo';
import ConsultationSchedule from '@/modules/Consultation/Schedule';
import ConsultationSelectPatient from '@/modules/Consultation/SelectPatient';
import PrescriptionStatus from '@/modules/PrescriptionStatus/PrescriptionStatus';
import Unsubscribe from '@/modules/Unsubscribe/Unsubscribe';
import DeleteUser, { DeleteUserResult } from '@/modules/DeleteUser';
import MentalHealth from '@/modules/MentalHealth';
import Content from '@/modules/Content';

interface Meta {
  pageTitle: string;
}

interface ComponentRoutesDefault {
  exact?: boolean;
  isNeedAuth?: boolean;
  meta?: Meta;
}

export interface ComponentRoutes extends ComponentRoutesDefault {
  Component: React.FC;
  path: string;
  children: RoutePathObject;
  isDoctor?: boolean;
}

export type RoutePathObject = ComponentRoutes[];

const patientRoutes: RoutePathObject = [
  {
    Component: Unsubscribe as React.FC,
    path: '/patient/order/:subscriptionID/unsubscribe',
    children: [],
  },
  {
    Component: Order as React.FC,
    path: '/patient/order/:subscriptionID',
    children: [],
  },
  {
    Component: Promo as React.FC,
    path: '/patient/promo',
    children: [],
  },
  {
    Component: PrescriptionStatus as React.FC,
    path: '/patient/prescription-status',
    children: [],
    isDoctor: true,
  },
  {
    Component: DeleteUser as React.FC,
    path: '/patient/delete-user/:userType',
    children: [],
    isNeedAuth: false,
  },
  {
    Component: DeleteUserResult as React.FC,
    path: '/patient/delete-user-result/:result',
    children: [],
    isNeedAuth: false,
  },
  {
    Component: MentalHealth as React.FC,
    path: '/patient/mental-health',
    children: [],
    isNeedAuth: false,
  },
  {
    Component: ConsultationSchedule as React.FC,
    path: '/patient/consultation-schedule/:doctorID',
    children: [],
    isNeedAuth: false,
  },
  {
    Component: ConsultationSelectPatient as React.FC,
    path: '/patient/consultation-select-patient',
    children: [],
    isNeedAuth: false,
  },
  {
    Component: Content as React.FC,
    path: '/patient/content/:title',
    children: [],
    isNeedAuth: false,
  },
];

const partnerRoutes: RoutePathObject = [
  {
    Component: OrderPharmacy as React.FC,
    path: '/partner/order-pharmacy/:orderID',
    children: [],
    isNeedAuth: false,
  },
];

const defaultComponentRoutesProps: ComponentRoutesDefault = {
  isNeedAuth: true,
  exact: true,
  meta: {} as Meta,
};

const joinDeclaredRoutePathObjectWithDefaultComponentRoutesProps: () => RoutePathObject = () =>
  [...patientRoutes, ...partnerRoutes].map(path => ({
    ...defaultComponentRoutesProps,
    ...path,
  }));

export default joinDeclaredRoutePathObjectWithDefaultComponentRoutesProps();
